import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '@shared/endpoints';
import {
    CreateReferralsRequest,
    UpdateReferralsRequest,
} from '../models/api/requests/referrals.request';
import { ReferralsResponse } from '../models/api/response/referrals.response';

@Injectable({
    providedIn: 'root',
})
export class ReferralsService {
    constructor(private http: HttpClient) {}

    fetchReferrals(
        id = '',
        isActive = false,
        includeExpired = false,
        includeNonBillableActions = false
    ) {
        let params = new HttpParams();
        if (id) {
            params = params.append('id', id);
        }
        if (isActive) {
            params = params.append('isActive', isActive);
        }
        if (includeExpired) {
            params = params.append('includeExpired', includeExpired);
        }
        if (includeNonBillableActions) {
            params = params.append(
                'includeNonBillableActions',
                includeNonBillableActions
            );
        }

        return this.http.get<ReferralsResponse[]>(
            endpoints.admin.children.getReferrals(),
            { params }
        );
    }
    createNewReferralRequest(payload: CreateReferralsRequest) {
        return this.http.post<ReferralsResponse>(
            endpoints.refs.children.createReferral(),
            { ...payload }
        );
    }
    updateReferralRequest(payload: UpdateReferralsRequest) {
        return this.http.post<ReferralsResponse>(
            endpoints.admin.children.updateReferral(),
            { ...payload }
        );
    }
}
